import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Container from './src/container.vue'
import Aside from './src/aside.vue'
import Footer from './src/footer.vue'
import Header from './src/header.vue'
import Main from './src/main.vue'

export const JdContainer = withInstall(Container, {
  Aside,
  Footer,
  Header,
  Main,
})

export default JdContainer
export const JdAside = withNoopInstall(Aside)
export const JdFooter = withNoopInstall(Footer)
export const JdHeader = withNoopInstall(Header)
export const JdMain = withNoopInstall(Main)

export type ContainerInstance = InstanceType<typeof Container>
export type AsideInstance = InstanceType<typeof Aside>
export type FooterInstance = InstanceType<typeof Footer>
export type HeaderInstance = InstanceType<typeof Header>
export type MainInstance = InstanceType<typeof Main>
